<div [formGroup]="fg">
  <p class="filter-label"><strong>States</strong></p>
  <a class="select-all" (click)="toggleSelectAll()">Select All</a>
  <clr-checkbox-wrapper *ngFor="let statOp of stateOptions">
    <input autocomplete="off" type="checkbox" clrCheckbox name="states" [value]="statOp" [formControlName]="'state_' + statOp"/>
    <label>{{getPrettyConstraintStateName(statOp)}}</label>
  </clr-checkbox-wrapper>
</div>
